import { readyAudioStatusSet } from '@listening/api-contract/audio-statuses';

type ProcessingQueueData = {
  pages: ReadonlyArray<{
    items: ReadonlyArray<{ conversion_status: string }>;
  }>;
};

const ACTIVE_PROCESSING_POLL_INTERVAL_MS = 5_000;
const activeProcessingStatusSet = new Set(['initializing', 'processingPDF']);

export function isActiveProcessingStatus(status: string) {
  return activeProcessingStatusSet.has(status);
}

export function processingQueueRefreshTransition(
  items: ReadonlyArray<{ id: string; conversion_status: string }>,
  previousActiveIds: ReadonlySet<string>,
  previousReadyIds: ReadonlySet<string>,
) {
  const currentIds = new Set(items.map((item) => item.id));
  const activeIds = new Set(
    items
      .filter((item) => isActiveProcessingStatus(item.conversion_status))
      .map((item) => item.id),
  );
  const readyIds = new Set(
    items
      .filter((item) => readyAudioStatusSet.has(item.conversion_status))
      .map((item) => item.id),
  );
  const activeItemFinished = [...previousActiveIds].some(
    (id) => !currentIds.has(id),
  );
  const newReadyItem = [...readyIds].some((id) => !previousReadyIds.has(id));

  return {
    activeIds,
    readyIds,
    shouldInvalidate: activeItemFinished || newReadyItem,
  };
}

export function processingQueuePollingDelayMs(
  data: ProcessingQueueData | undefined,
) {
  const hasActiveConversion = data?.pages.some((page) =>
    page.items.some((item) => isActiveProcessingStatus(item.conversion_status)),
  );
  return hasActiveConversion ? ACTIVE_PROCESSING_POLL_INTERVAL_MS : false;
}
